import React, { useContext, useEffect, useState, useRef } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import ClaimsList from "./list";
import VehicleContext from "../../context/index";
import withStyles from "@material-ui/core/styles/withStyles";
import { useStyles } from "./styles";
import {
  download,
  extractFileName,
  getLendingRoute,
  parseMessage,
  redirectWithBlank,
  setStorageItem,
} from "../../helpers/utils";
import { getWebService, postWebService } from "../../helpers/server";
import {
  buildClaimsListToExport,
  isPolicyCancellationInitiated,
  isPolicyCancelled,
} from "../../helpers/policy";
import { ReducerUtils } from "../../constants/reducers";
import { Utils } from "../../constants/utils";
import { toast } from "react-toastify";
import {
  ALL_STATUS,
  CLAIM_STATUS_INITIATED_SLUG,
  PARTNER_ID_MOBILE_STACK_DEMO,
  PAYLOAD_CLAIM_DOCUMENTS,
  PAYLOAD_DELETE_EXISTING_DOCUMENT,
  PAYLOAD_DOCUMENT_TPYE_ID,
  DOCUMENT_TPYE_ID_MOBILE_PHOTOS,
  DOCUMENT_TPYE_ID_ESTIMATE,
  DOCUMENT_TPYE_ID_INVOICE,
  DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS,
  SLUG_DAMAGED_MOBILE,
  SLUG_ESTIMATE_MOBILE,
  SLUG_INVOICE_MOBILE,
  SLUG_OPEN,
  SLUG_REPAIRED_MOBILE,
  SOURCE_SERVICE_CENTRE,
  SLUG_UPLOADED_DAMAGED_MOBILE,
  SLUG_UPLOADED_ESTIMATE_MOBILE,
  SLUG_UPLOADED_INVOICE_MOBILE,
  SLUG_UPLOADED_REPAIRED_MOBILE,
  CLAIM_STATUS_SUBMITTED,
} from "../../constants/index";
import {
  buildClaimsList,
  buildGeneratePaymentLinkPayload,
  buildSystemErrorMessage,
  downloadExcel,
} from "../../helpers/proposal";
import { Box } from "@material-ui/core";
import { useHistory } from "react-router";
import { durationMapping } from "../../mapping";
import { defaultModalObject, defaultPhotoObject } from "../../defaultValues";

function Policies({ classes: { loaderBox }, value = 0, handleTabChange = {} }) {
  const { state, dispatch } = useContext(VehicleContext);
  const history = useHistory();
  const selectInputRef = useRef();
  const [claimData, setClaimData] = useState([]);
  const [claimId, setClaimId] = useState(null);
  const [clearFilter, setClearFilter] = useState(false);
  const [errors, setErrors] = useState([]);
  const [filter, setFilter] = useState({
    search: state.searchText ?? "",
    tab: 2,
    status: ALL_STATUS,
  });
  const [isExportClicked, setIsExportClicked] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSearchResultLoaded, setIsSearchResultLoaded] = useState(false);
  const [modal, setModal] = useState(defaultModalObject);
  const [pagination, setPagination] = useState({ currentPage: 0 });
  const [photo, setPhoto] = useState(defaultPhotoObject);

  useEffect(() => getClaimsList(), [value]);
  useEffect(() => clearFilter && getClaimsList(), [clearFilter]);
  useEffect(() => {
    dispatchEvent(ReducerUtils.filter.status, filter.status);
    setFilter({
      ...filter,
      search: "",
    });
    setPagination({
      ...pagination,
      currentPage: 0,
    });
    setClearFilter(false);
  }, [filter.status]);

  const buildDamagedPhonePhotoRequestPayload = () => {
    const payload = new FormData();

    payload.append(PAYLOAD_DOCUMENT_TPYE_ID, DOCUMENT_TPYE_ID_MOBILE_PHOTOS);
    payload.append(PAYLOAD_CLAIM_DOCUMENTS, photo[SLUG_DAMAGED_MOBILE]);
    payload.append(PAYLOAD_DELETE_EXISTING_DOCUMENT, 1);

    return payload;
  };

  const buildEstimatePhotoRequestPayload = () => {
    const payload = new FormData();

    payload.append(PAYLOAD_DOCUMENT_TPYE_ID, DOCUMENT_TPYE_ID_ESTIMATE);
    payload.append(PAYLOAD_CLAIM_DOCUMENTS, photo[SLUG_ESTIMATE_MOBILE]);
    payload.append(PAYLOAD_DELETE_EXISTING_DOCUMENT, 1);

    return payload;
  };

  const buildInvoicePhotoRequestPayload = () => {
    const payload = new FormData();

    payload.append(PAYLOAD_DOCUMENT_TPYE_ID, DOCUMENT_TPYE_ID_INVOICE);
    payload.append(PAYLOAD_CLAIM_DOCUMENTS, photo[SLUG_INVOICE_MOBILE]);
    payload.append(PAYLOAD_DELETE_EXISTING_DOCUMENT, 1);

    return payload;
  };

  const buildRepairedMobilePhotoRequestPayload = () => {
    const payload = new FormData();

    payload.append(
      PAYLOAD_DOCUMENT_TPYE_ID,
      DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS
    );
    payload.append(PAYLOAD_CLAIM_DOCUMENTS, photo[SLUG_REPAIRED_MOBILE]);
    payload.append(PAYLOAD_DELETE_EXISTING_DOCUMENT, 1);

    return payload;
  };

  const cbGetClaimList = (
    { data: { claims = [], message }, data, success },
    isExport
  ) => {
    if (success && !isExport) {
      setClaimData(claims);
      dispatchEvent(ReducerUtils.claims.list, buildClaimsList(claims));
      dispatchEvent(
        ReducerUtils.claims.count,
        Math.ceil(claims.length / ReducerUtils.claims.perPage)
      );
      setIsLoaded(true);
      setIsSearchResultLoaded(true);
    } else if (success && isExport) {
      notify(message);
      setIsExportClicked(false);
    }
  };

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const getClaimsList = async (isExport = false) => {
    setIsSearchResultLoaded(false);
    const response = await getWebService(
      `partners/claim?page=0&partner_id=${PARTNER_ID_MOBILE_STACK_DEMO}&date=${durationMapping[value]}&source=${SOURCE_SERVICE_CENTRE}`
    );

    cbGetClaimList(response.data, isExport);
  };

  const cbError = ({ data: { error_msg } }) => {
    setIsFormSubmitted(false);

    const message = parseMessage(error_msg);
    if (Array.isArray(message)) {
      setErrors(message);
    } else {
      let messageArray = [];
      messageArray.push(message);
      setErrors(messageArray);
    }

    setModal({ ...modal, [SLUG_OPEN]: true });
  };

  const downloadFile = (url) => redirectWithBlank(url); //download(url, extractFileName(url));

  const onPagination = (pageNumber) => {
    setPagination({
      ...pagination,
      currentPage: pageNumber - 1,
    });
  };

  const onRowClick = ({ id = null, order_id = null, status = null }) => {
    const allowedStatus = [CLAIM_STATUS_INITIATED_SLUG, CLAIM_STATUS_SUBMITTED];
    if (allowedStatus.indexOf(status.toLowerCase().replace(" ", "_")) === -1) {
      return false;
    }

    history.push(`${getLendingRoute("newClaim")}/${id}?ref=${order_id}`);
  };

  const onSearchChange = (event) =>
    setFilter({ ...filter, [event.target.name]: event.target.value });

  const onSearchClickHandler = (e) => {
    e.preventDefault();

    dispatchEvent(ReducerUtils.search.text, filter.search);
    setPagination({
      ...pagination,
      currentPage: 0,
    });
    setClearFilter(false);
  };

  const handleClose = (flag = false, keyname = SLUG_OPEN) =>
    setModal({ ...modal, [keyname]: flag });

  const isPolicyInActive = (status, active = null) =>
    isPolicyCancellationInitiated(status) ||
    isPolicyCancelled(status) ||
    status.toLowerCase().replace(" ", "_") === "settlement_completed";

  const handleChange = (event) => {
    setFilter({ ...filter, [event.target.name]: event.target.value });
  };

  const handleEstimateClick = (event, item) => {
    event.stopPropagation();

    onRowClick(item);
  };

  const handleInitiateClaim = () =>
    redirectWithBlank(process.env.REACT_APP_CUSTOMER_PORTAL_URL);

  const handleOnClose = (event, reason, filterName = "dateFilter") => {
    if (Utils.dialogOnCloseReasons.indexOf(reason) === -1) {
      handleClose(false, filterName);
    }
  };

  const handlePaymentLinkClick = async (event, { id }) => {
    event.stopPropagation();

    try {
      await postWebService(
        "payments/link",
        buildGeneratePaymentLinkPayload(id)
      );

      getClaimsList();
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const handlePolicyExport = () =>
    downloadExcel(buildClaimsListToExport(state.filteredClaimsList));

  const handleRemarksClick = (item) => {
    dispatchEvent(ReducerUtils.claims.remarks, item.claim_remarks);
    setModal({ ...modal, remark: true });
  };

  const handleSearchKeyPress = (event) => {
    if (event.charCode === 13) {
      onSearchClickHandler(event);
    }
  };

  const notify = (message) => toast.success(message);

  const photoChangeHandler = (keyname, file) => {
    setPhoto({
      ...photo,
      [keyname]: file,
    });
  };

  const submitHandler = async (payload, modalKey, storageKey) => {
    try {
      setErrors([]);
      setIsSearchResultLoaded(false);
      setIsFormSubmitted(true);
      const response = await postWebService(
        `web/claim/document/submit/${claimId}`,
        payload
      );
      const { data, status } = response.data;
      setModal({ ...modal, [modalKey]: false });
      setStorageItem(`${storageKey}_${claimId}`, 1);
      setIsSearchResultLoaded(true);
      setIsFormSubmitted(false);
      getClaimsList();
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const submitDamageMobileHandler = async () => {
    submitHandler(
      buildDamagedPhonePhotoRequestPayload(),
      SLUG_DAMAGED_MOBILE,
      SLUG_UPLOADED_DAMAGED_MOBILE
    );
  };

  const submitEstimateHandler = async () => {
    submitHandler(
      buildEstimatePhotoRequestPayload(),
      SLUG_ESTIMATE_MOBILE,
      SLUG_UPLOADED_ESTIMATE_MOBILE
    );
  };

  const submitInvoiceHandler = async () => {
    submitHandler(
      buildInvoicePhotoRequestPayload(),
      SLUG_INVOICE_MOBILE,
      SLUG_UPLOADED_INVOICE_MOBILE
    );
  };

  const submitRepairedMobileHandler = () =>
    submitHandler(
      buildRepairedMobilePhotoRequestPayload(),
      SLUG_REPAIRED_MOBILE,
      SLUG_UPLOADED_REPAIRED_MOBILE
    );

  const tabChange = (event, newValue) => handleTabChange(event, newValue);

  const uploadClickHandler = (id, modalKey = "") => {
    setModal({ ...modal, [modalKey]: true });
    setClaimId(id);
  };

  return isLoaded ? (
    <ClaimsList
      downloadFile={downloadFile}
      errors={errors}
      filter={filter}
      handleChange={handleChange}
      handleClose={handleClose}
      handleEstimateClick={handleEstimateClick}
      handleInitiateClaim={handleInitiateClaim}
      handleOnClose={handleOnClose}
      handlePaymentLinkClick={handlePaymentLinkClick}
      handlePolicyExport={handlePolicyExport}
      handleRemarksClick={handleRemarksClick}
      handleSearchKeyPress={handleSearchKeyPress}
      isExportClicked={isExportClicked}
      isFormSubmitted={isFormSubmitted}
      isPolicyInActive={isPolicyInActive}
      isSearchResultLoaded={isSearchResultLoaded}
      modal={modal}
      onPagination={onPagination}
      onSearchChange={(value) => onSearchChange(value)}
      onSearchClickHandler={onSearchClickHandler}
      openSearch={true}
      onRowClick={onRowClick}
      pagination={pagination}
      photo={photo}
      photoChangeHandler={photoChangeHandler}
      selectInputRef={selectInputRef}
      submitDamageMobileHandler={submitDamageMobileHandler}
      submitEstimateHandler={submitEstimateHandler}
      submitInvoiceHandler={submitInvoiceHandler}
      submitRepairedMobileHandler={submitRepairedMobileHandler}
      tabChange={tabChange}
      uploadClickHandler={uploadClickHandler}
      value={value}
      {...{ getClaimsList, claimData }}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(Policies);
